export const scrollIntoViewOptions: ScrollIntoViewOptions = {
  behavior: 'smooth',
  block: 'nearest',
  inline: 'start',
};

// used to skip over for quick enter search
export const RECENT_SEARCHES_SECTION_TITLE = 'Recent Searches';
